import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

import { User } from '@models/users/user.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() user: User;
  @Input() menuItems = [];

  @HostBinding('class.has-background') @Input() hasBackground = false;

  @Output() menuClick = new EventEmitter<any>();

  ngOnInit() {
  }

  clickMenu() {
    this.menuClick.emit();
  }
}
